import { Grid, InputLabel, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { editInstantRequest } from "../../../utils/formHelper";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import _ from "lodash";

const AutresLettreIntentionAchat = ({
  currentMandat,
  setCurrentMandat,
  refresh,
  disabledSign = false,
}) => {
  const [autresLettres, setAutresLettres] = useState("");
  const [financement, setFinancement] = useState("");

  return (
    <>
      <Grid container columnSpacing={1} rowSpacing={3} padding={4}>
        <InputLabel id="dateLabel" size="small" sx={{ color: "black" }}>
          Cette proposition est valable jusqu'au (inclus)*
        </InputLabel>{" "}
        <DatePicker
          disabled={disabledSign}
          sx={{ paddingLeft: "10px", marginTop: "10px" }}
          size="small"
          value={
            currentMandat.dateFinLettreIntention
              ? moment(currentMandat.dateFinLettreIntention)
              : null
          }
          format="DD/MM/YYYY"
          onChange={(date) => {
            let dateToSend = date?.toLocaleString("fr-FR", {
              timeZone: "Europe/paris",
            });
            if (dateToSend !== "Invalid date") {
              editInstantRequest(
                _.isNull(dateToSend) ? null : dateToSend,
                currentMandat["@id"],
                "dateFinLettreIntention",
              );
              refresh();
            }
          }}
          slotProps={{
            textField: {
              size: "small",
            },
          }}
        />
      </Grid>
      <Grid
        container
        columnSpacing={1}
        rowSpacing={1}
        padding={4}
        sx={{ alignItems: "center" }}
      >
        <Grid item md={2} xs={12}>
          <Typography noWrap>Autres</Typography>
        </Grid>
        <Grid item md={10} xs={12}>
          <TextField
            disabled={disabledSign}
            fullWidth
            size="large"
            multiline={true}
            rows={5}
            id="autresLettres"
            value={
              autresLettres !== "" ? autresLettres : (currentMandat.autresLettres || "")
            }
            // Besoin de changer la valeur du state pour que le composant se rafraichisse
            onChange={(e) => {
              setAutresLettres(e.target.value);
            }}
            // On envoie la valeur au serveur
            onBlur={(e) => {
              let m = editInstantRequest(
                e.target.value,
                currentMandat["@id"],
                "autresLettres",
              );

              m.then((m) => {
                if (m["@context"] === "/api/contexts/Error") {
                  refresh();
                } else {
                  setCurrentMandat(m);
                }
              });
            }}
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <Typography noWrap>
            Cette acquisition sera financée de la manière suivante* :
          </Typography>
        </Grid>
        <Grid item md={12} xs={12}>
          <TextField
            disabled={disabledSign}
            fullWidth
            size="large"
            multiline={true}
            rows={5}
            id="financement"
            value={financement !== "" ? financement : (currentMandat.financement || "")}
            // Besoin de changer la valeur du state pour que le composant se rafraichisse
            onChange={(e) => {
              setFinancement(e.target.value);
            }}
            // On envoie la valeur au serveur
            onBlur={(e) => {
              let m = editInstantRequest(
                e.target.value,
                currentMandat["@id"],
                "financement",
              );
              m.then((m) => {
                if (m["@context"] === "/api/contexts/Error") {
                  refresh();
                } else {
                  setCurrentMandat(m);
                }
              });
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default AutresLettreIntentionAchat;
